import { get } from "http";
import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";


export function useSentimentAnalysisApi() {
  const callApi = useApiCall();

  const getSentimentTimeline = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SENTIMENT.GET_SENTIMENT_TIMELINE, data, onSuccess, onError);
  }

  const getSentimentBreakdown = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SENTIMENT.GET_SENTIMENT_BREAKDOWN, data, onSuccess, onError);
  }

  const getSentimentOverall = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SENTIMENT.GET_SENTIMENT_OVERALL, data, onSuccess, onError);
  }

  const getSentimentComparison = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SENTIMENT.GET_SENTIMENT_COMPARISON, data, onSuccess, onError);
 }

  const getReviewVolumn = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SENTIMENT.GET_REVIEW_VOLUMN, data, onSuccess, onError);
  }

  const getRatingStars = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SENTIMENT.GET_REVIEW_RATING, data, onSuccess, onError);
  }

  return {
    getSentimentTimeline,
    getSentimentBreakdown,
    getSentimentOverall,
    getSentimentComparison,
    getReviewVolumn,
    getRatingStars,
  };
}
